import React from 'react'
import { AttachmentPreview, Flexbox } from '@/components'

type AttachmentsProps = {
  attachments: string[]
}

function Attachments({ attachments }: AttachmentsProps) {
  if (!attachments) return null

  return (
    <Flexbox.Columns className="col-gapless">
      {
        attachments.map((uri) => (
          <Flexbox.Column key={uri} className="col-auto mr-1">
            <AttachmentPreview src={uri} size={30} />
          </Flexbox.Column>
        ))
      }
    </Flexbox.Columns>
  )
}

export default Attachments
